import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Utilities
import { mapState } from 'vuex';
import { themeColors } from '../../utils/themes';
export default {
  name: 'CoreFilter',
  data: function data() {
    return {
      colors: themeColors,
      mapStyles: [{
        text: 'niotix',
        value: '1'
      }, {
        text: 'Satellite',
        value: '2'
      }, {
        text: 'Streets',
        value: '3'
      }, {
        text: 'Combo',
        value: '4'
      }],
      mapStyle: localStorage.getItem('mapStyle')
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'drawer', 'UiTheme', 'map3DBuild', 'language', 'themes', 'miniVariant', 'color', 'colorHexLight', 'colorHexDark'])), {}, {
    lang: function lang() {
      return this.$store.state.app.language;
    },
    hasCustomColor: function hasCustomColor() {
      return this.UiTheme ? this.colorHexDark : this.colorHexLight;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: {
    resetDefaults: function resetDefaults() {
      localStorage.setItem('thingshiveColorLight', this.$store.state.app.themes.light.highlight);
      localStorage.setItem('thingshiveColorDark', this.$store.state.app.themes.dark.highlight);
      this.$store.state.app.UiTheme = this.$store.state.app.themeMode === 'dark';
      this.setUiTheme();
    },
    setColor: function setColor(color) {
      var mode = this.$store.state.app.UiTheme ? 'dark' : 'light';

      if (color === 'customerColor') {
        this.$store.state.app.color = mode === 'dark' ? 'customerColorDark' : 'customerColorLight';
      } else {
        this.$store.state.app.color = color;
      }

      if (mode === 'dark') {
        localStorage.setItem('thingshiveColorDark', this.$store.state.app.color);
      } else {
        localStorage.setItem('thingshiveColorLight', this.$store.state.app.color);
      }
    },
    mapLayoutSelected: function mapLayoutSelected() {
      localStorage.setItem('mapStyle', this.mapStyle);
      this.$store.state.app.mapStyle = this.mapStyle;
    },
    setLang: function setLang(lang) {
      this.$store.commit('app/language', {
        payload: lang,
        context: this
      });
      localStorage.setItem('language', lang);
    },
    setImage: function setImage(image) {
      this.$store.state.app.image = image;
      localStorage.setItem('thingshiveImage', this.$store.state.app.image);
    },
    setUiTheme: function setUiTheme() {
      var mode = this.$store.state.app.UiTheme ? 'dark' : 'light';
      var userHighlight = mode === 'dark' ? localStorage.getItem('thingshiveColorDark') : localStorage.getItem('thingshiveColorLight');
      localStorage.setItem('thingshiveTheme', mode);
      this.$store.state.app.color = userHighlight || this.themes[mode].highlight;
      this.$store.state.app.mode = mode;
      this.$vuetify.theme.dark = this.$store.state.app.UiTheme;
    },
    setMap3DBuild: function setMap3DBuild() {
      localStorage.setItem('thingshiveMap3DBuild', this.$store.state.app.map3DBuild ? '3D' : '2D');
    },
    setMiniVariant: function setMiniVariant() {
      localStorage.setItem('miniVariant', this.$store.state.app.miniVariant);
    },
    setLoader: function setLoader(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.$store.state.app.load = a;
      this.$store.state.app.loading = b;
    }
  }
};